<template>
    <div v-if="pending" class="text-center" style="transition: none !important;">
        <b-spinner/>
    </div>

    <main v-else>
        <header class="justify-between align-items-stretch mb-3">
            <b-breadcrumb class="flex-grow-1 mb-0">
                <b-breadcrumb-item :to="{ name: 'disabilities.index' }">
                    {{ $t('Disabilities') }}
                </b-breadcrumb-item>

                <b-breadcrumb-item active>
                    {{ id ? item.originalData.name : $t('Create') }}
                </b-breadcrumb-item>
            </b-breadcrumb>

            <b-dropdown
                v-if="id"
                :id="'disability_actions_dropdown_' + item.id"
                :title="$t('Actions')"
                class="ml-3"
                right
                no-caret
            >
                <template slot="button-content">
                    <fa icon="ellipsis-v" fixed-width/>
                </template>

                <b-dropdown-item variant="danger" @click="handleDelete">
                    <fa icon="trash" fixed-width/>
                    {{ $t('Delete') }}
                </b-dropdown-item>
            </b-dropdown>
        </header>

        <b-card class="mb-3" no-body tag="section">
            <b-form
                @submit.prevent="handleSave"
                @keydown="item.onKeydown($event)"
            >
                <b-card-body>
                    <b-form-group
                        :label="$t('Name')"
                        label-for="name"
                        :state="item.errors.has('name') ? false : null"
                        :invalid-feedback="item.errors.get('name')"
                    >
                        <b-form-input
                            id="name"
                            v-model="item.name"
                            name="name"
                            :state="item.errors.has('name') ? false : null"
                        />
                    </b-form-group>

                    <b-form-group
                        :label="$t('Type')"
                        :invalid-feedback="item.errors.get('type')"
                        :state="item.errors.has('type') ? false : null"
                    >
                        <b-form-radio-group
                            v-model="item.type"
                            :options="types"
                            :state="item.errors.has('type') ? false : null"
                            name="type"
                        />
                    </b-form-group>
                </b-card-body>

                <b-card-footer>
                    <b-button
                        :disabled="item.busy"
                        type="submit"
                        variant="primary"
                    >
                        {{ id ? $t('Save') : $t('Create') }}
                        <b-spinner v-show="item.busy" small/>
                    </b-button>
                </b-card-footer>
            </b-form>
        </b-card>
    </main>
</template>

<script>
    import {DISABILITY_TYPES} from "@/constants";
    import itemMixin from "@/mixins/itemMixin";


    export default {
        name: 'Disability',
        mixins: [itemMixin],
        props: {
            id: {
                type: [Number, String],
                default: null,
            },
        },
        computed: {
            resourceName() {
                return 'disabilities'
            },
            types() {
                return Object.values(DISABILITY_TYPES).map(value => (
                    {
                        text: this.$t(value),
                        value
                    })
                )
            }
        },
    };
</script>
